import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {EmailGroup, EmailList} from "../../../NIBINInterface";
import {EmailService} from "../../../services/email.service";
import {AuthService} from "../../../services/auth.service";
import Swal from "sweetalert2";

@Component({
  selector: 'app-add-email-replyto-list',
  templateUrl: './add-email-replyto-list.component.html',
  styleUrls: ['./add-email-replyto-list.component.css']
})
export class AddEmailReplytoListComponent implements OnInit {

  EmailGroups: EmailGroup[] = []
  newEmail: EmailList = <EmailList>{group:'Default'};
  @Output('NewEmailTrigger') NewEmailTrigger = new EventEmitter<EmailList>();
  constructor(private emailService:EmailService,private  authService: AuthService) { }

  ngOnInit(): void {}

  saveEmail() {
    this.newEmail.deptCode=this.authService.getUser().CurrentDept

    this.emailService.addReplyToEmailToList(this.newEmail).then((r)=>{
      this.NewEmailTrigger.emit(this.newEmail)


      Swal.fire({
        icon: 'success',
        title: 'System Notification',
        text: "Email Successfully Added",
        timerProgressBar:true,
        timer:4000
      })

      //reset form
      this.newEmail = <EmailList>{}

    })
  }
}
